import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "weather-timestamp"
}

import { onMounted, onBeforeUnmount, watch, ref } from "vue";
import L from "leaflet";


export default /*@__PURE__*/_defineComponent({
  __name: 'OpenWeatherLayer',
  props: {
    map: {},
    layer: {},
    opacity: {}
  },
  setup(__props: any) {

const props = __props;

let tileLayer: any = null;
const timestamp = ref<string>("");

const formatTime = () => {
	const now = new Date();
	return now.toLocaleTimeString("it-IT", {
		hour: "2-digit",
		minute: "2-digit",
	});
};

const createTileUrl = (layer: string) => {
	return `/proxy/owm-tiles/${layer}/{z}/{x}/{y}.png`;
};

const updateLayer = () => {
	if (!props.map) return;

	// Remove existing
	if (tileLayer) {
		tileLayer.remove();
		tileLayer = null;
	}

	// Add new
	const url = createTileUrl(props.layer);
	console.log(
		`[OpenWeatherLayer] Adding layer: ${props.layer} to map`,
		props.map,
	);

	try {
		tileLayer = L.tileLayer(url, {
			maxZoom: 18,
			attribution:
				'&copy; <a href="https://openweathermap.org/">OpenWeatherMap</a>',
			opacity: props.opacity || 1.0,
			zIndex: 100, // Ensure it overlays base map but is below controls
		});

		tileLayer.on("tileerror", (e: any) => {
			console.warn(`[OpenWeatherLayer] Tile error for ${props.layer}:`, e);
		});

		tileLayer.addTo(props.map);
		timestamp.value = formatTime();
		console.log(`[OpenWeatherLayer] Layer added successfully`);
	} catch (e) {
		console.error(`[OpenWeatherLayer] Error adding layer:`, e);
	}
};

onMounted(() => {
	updateLayer();
});

onBeforeUnmount(() => {
	if (tileLayer) {
		tileLayer.remove();
		tileLayer = null;
	}
});

watch(
	() => props.layer,
	() => {
		updateLayer();
	},
);

watch(
	() => props.map,
	(newMap) => {
		if (newMap) updateLayer();
	},
);

return (_ctx: any,_cache: any) => {
  return (_unref(tileLayer))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " ⏱️ Dati meteo: " + _toDisplayString(timestamp.value), 1))
    : _createCommentVNode("", true)
}
}

})